import React, { FC, Fragment, PropsWithChildren } from "react";
import styled from "styled-components";
import { CardProps } from "./Div";
import {
  Color,
  setAlignItems,
  setAlignSelf,
  setBackgroundColor,
  setBorder,
  setFlex,
  setFlexDirection,
  setJustifyContent,
  setShadow,
  setStyle,
} from "../../StyleSheet";
import { useTranslation } from "react-i18next";
import { Text } from "./Text";
import { Icon } from "./Icon";
import { IconProps } from "iconsax-react";
import { PuffLoader } from "react-spinners";
import { useThemeColors } from "../../Store/modules/theme";

export type ButtonProps = CardProps & {
  title: string;
  StartIconComponent?: FC<IconProps>;
  EndIconComponent?: FC<IconProps>;
  textColor?: Color;
  textClassName?: string;
  loading?: boolean;
  iconColor?: Color;
  disabled?: boolean;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  display?: string;
};

const StyledButton = styled.button<CardProps>`
  ${setBackgroundColor};
  ${setBorder};
  ${setFlex};
  ${setAlignSelf};
  ${setAlignItems};
  ${setJustifyContent};
  ${setFlexDirection};
  ${setShadow};
  ${setStyle};
`;
export const Button: React.FC<
  PropsWithChildren<Omit<ButtonProps, "children">>
> = (props) => {
  const {
    locale,
    title,
    textClassName,
    textColor = "white",
    StartIconComponent,
    EndIconComponent,
    loading,
    iconColor,
    disabled,
    display,
    bg,
    onClick,
    className,
    ...restProps
  } = props;

  const [theme] = useThemeColors();
  const { i18n } = useTranslation();

  return (
    <StyledButton
      {...restProps}
      bg={disabled ? "tertiary" : bg}
      locale={locale || i18n.language}
      flexDirection="row"
      className={`outline-0 rounded-[5px] ${display ?? "flex justify-center items-center"} ${className ? className : ""}`}
      onClick={(e) => {
        if (!disabled && !loading) {
          onClick && onClick(e);
        }
      }}
    >
      {loading ? (
        <PuffLoader
          size={24}
          color={bg === "transparent" || !bg ? theme["primary"] : "white"}
        />
      ) : (
        <Fragment>
          {EndIconComponent ? (
            <div className="md:mx-1">
              <Icon
                Component={EndIconComponent}
                size={18}
                color={iconColor ?? "white"}
              />
            </div>
          ) : null}
          <Text
            elementType="span"
            className={textClassName}
            color={textColor}
            fontWeight={400}
          >
            {title}
          </Text>
          {StartIconComponent ? (
            <div className="md:mx-1">
              <Icon
                Component={StartIconComponent}
                size={18}
                color={iconColor ?? "white"}
              />
            </div>
          ) : null}
        </Fragment>
      )}
    </StyledButton>
  );
};
